



































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import {
  GQL_ameldingNewData_currentUnit_subUnits,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality_employerTaxZone,
} from '@/queries/__generated__/ameldingNewData';
import AmeldingFormWorkRelation from './AmeldingFormWorkRelation.vue';
import AmeldingFormAdditionalFields from './AmeldingFormAdditionalFields.vue';
import { AdditionalField, WithSelectedFlag } from './AmeldingForm.vue';
import uniqBy from 'lodash/uniqBy';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_unitPaycheckSetting, GQL_unitPaycheckSetting_currentUnit_unitSetting_unitPaycheckSetting } from '@/queries/__generated__/unitPaycheckSetting';
import { UNIT_PAYCHECK_SETTINGS } from '@/queries/CompanySetting';

@Component({
  components: {
    AmeldingFormWorkRelation,
    AmeldingFormAdditionalFields,
  },
})
export default class AmeldingFormSubUnit extends Vue {
  private debug = false;

  @Prop({ type: Object, required: true }) private subUnit!: GQL_ameldingNewData_currentUnit_subUnits;
  @Prop({ type: Array, required: true }) private additionalFields!: AdditionalField[];

  @SmartQuery<AmeldingFormSubUnit, GQL_unitPaycheckSetting>({
    query: UNIT_PAYCHECK_SETTINGS,
    update: data => data.currentUnit.unitSetting.unitPaycheckSetting,
  }) public unitPaycheckSetting!: GQL_unitPaycheckSetting_currentUnit_unitSetting_unitPaycheckSetting;

  private get selectedMunicipalities(): GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality[] {
    if (!this.unitPaycheckSetting) return [];

    return uniqBy(
      this.subUnit.workRelations
        .flatMap(wr =>
          (wr.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
            .filter(p => p.$_selected)
            .map(p => p.companyMunicipality),
        ).concat(
          (this.subUnit.workRelations as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations>[])
            .some(wr =>
              wr.$_selected &&
          (wr.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
            .every(p => !p.$_selected),
            )
            ? [ this.unitPaycheckSetting.municipality! ]
            : [],
        ),
      m => m.id,
    );
  }

  private get selectedEmployerTaxZones(): GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality_employerTaxZone[] {
    return uniqBy(this.selectedMunicipalities.map(m => m.employerTaxZone), z => z.id);
  }

  @Ref() public workRelationForms?: AmeldingFormWorkRelation[];

  @Watch('selectedEmployerTaxZones')
  private updateAdditionalFieldsList(): void {
    this.additionalFields.forEach(f => {
      if (!this.selectedEmployerTaxZones.find(z => f.employerTaxZoneId === z.id)) {
        this.$emit(
          'employerTaxZoneDeselected',
          { subUnitId: this.subUnit.id, employerTaxZoneId: f.employerTaxZoneId },
        );
      }
    });

    this.selectedEmployerTaxZones.forEach(z => {
      if (!this.additionalFields.find(f => f.employerTaxZoneId === z.id)) {
        this.$emit(
          'employerTaxZoneSelected',
          { subUnitId: this.subUnit.id, employerTaxZoneId: z.id },
        );
      }
    });
  }
}
